module.exports = __webpack_public_path__ + "media/images/intro-side-aaa7cd6feacf0207f7af06832a75e897.jpg";